export default __webpack_public_path__ + "static/media/timer.3583f40d.mp3";